import { createApp } from 'vue';
import App from './App.vue';
import router, { setupGtmRouteTracking } from './router';
import store from './store';
import './assets/scss/style.scss';
import { setupValidator } from '@/plugins/validation';
import ElementPlus from 'element-plus';
import 'element-plus/theme-chalk/index.css';
import 'element-plus/theme-chalk/display.css';

// �O���[�o����CSS�̃C���|�[�g
import './assets/css/style.css';
import './assets/js/script.css';
import './assets/js/script.js';
import gtm from './plugins/gtm';

setupValidator();

const app = createApp(App)
  .use(gtm, {
    gtmIds: [process.env.GTM_ID1, process.env.GTM_ID2],
    store: store,
  })
  .use(store)
  .use(router)
  .use(ElementPlus);

setupGtmRouteTracking(app);

app.mount('#app');
